
import ContentContainer from "@/components/containers/contentContainer";
import { CertificationUpdater } from "./components/CertificationUpdater";
import CertificationsTable from "./components/CertificationsTable";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface UpdateCertificationsProps {
  skipContainer?: boolean;
}

const UpdateCertifications = ({ skipContainer = false }: UpdateCertificationsProps) => {
  const { t } = useTranslation();
  const [refetchCertificationsDependency, setRefechCertificationsDependency] =
    useState(false);

  const refetchCertificationsHandler = () => {
    setRefechCertificationsDependency((prevState) => !prevState);
  };

  const content = (
    <div className='flex flex-col gap-6'>
      <h1 className='text-2xl text-black font-bold'>{t('certifications')}</h1>

      {/* Instruction block */}
      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
        <p className="font-semibold mb-2">{t('certificationsInstructionTitle')}</p>
        <ul className="list-none space-y-1 mb-2">
          <li>✔ {t('certificationsInstructionItem1')}</li>
          <li>✔ {t('certificationsInstructionItem2')}</li>
          <li>✔ {t('certificationsInstructionItem3')}</li>
        </ul>
        <p className="text-gray-600 mb-1">{t('certificationsInstructionPdfLimit')}</p>
        <p className="text-gray-700 font-medium">{t('certificationsInstructionApproval')}</p>
      </div>

          <div className="row">
            <div className="col-lg-12">
              {/* <!-- Ls widget --> */}
              <div className="cv-manager-widget ls-widget">
                <div className="widget-title"></div>
                {/* End widget-title */}
                <div className="widget-content">
                  <CertificationUpdater
                    refetchCertifications={refetchCertificationsHandler}
                  />
                </div>
                {/* End widget-content */}
              </div>
              <div
                className="cv-manager-widget ls-widget"
                style={{ padding: 20 }}
              >
                <CertificationsTable
                  refetchDependency={refetchCertificationsDependency}
                  refetchCertifications={refetchCertificationsHandler}
                />
              </div>
              {/* Optional disclaimer */}
              <p className="text-xs text-gray-500 mt-2" style={{ fontStyle: 'italic' }}>
                {t('certificationsDisclaimer')}
              </p>
              {/* End Ls widget */}
            </div>
            {/* End .col */}
          </div>
          </div>
  );

  if (skipContainer) {
    return <div className='p-6'>{content}</div>;
  }

  return (
    <ContentContainer className='!px-0 m-0 bg-gray-100'>
      {content}
    </ContentContainer>
  );
};

export default UpdateCertifications;
